// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.texto{
    padding-left: 8rem;
    padding-right: 8rem;
}

.tittle{
    font-family: "Montserrat", sans-serif;
    font-size: 2rem;
    font-weight: 700;
}

.modal-size{
    width: 70vw; 
    max-width: 650px;
}

.neocheck-size{
    width: 60vw;
}



@media screen and (min-width: 2560px){
    .content-size{
        max-height: auto ;
    }
}


@media screen and (min-width: 1920px) and (max-width: 2559px){
    .modal-size{
        width: 70vw; 
        max-width: 650px;
    }
    
    .neocheck-size{
        width: 70vw;
    }
    
    .content-size{
        max-height: 90vh;
    }
}

@media screen and (min-width: 1366px) and (max-width: 1919px){
    .modal-size{
        width: 70vw; 
        max-width: 650px;
    }
    
    .neocheck-size{
        width: 95vw;
    }
    
    .content-size{
        max-height: 90vh;
    }
}

@media screen and (min-width: 1024px) and (max-width: 1365px){
    .content-size{
        max-height: 90vh;
    }
}

@media screen and (max-width: 480px){
    .neocheck-size{
        width: 85vw;
    }
    .modal-size{
        width: 85vw; 
      }
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-kyc/modal-kyc.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;;;AAIA;IACI;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;MACb;AACN","sourcesContent":[".texto{\n    padding-left: 8rem;\n    padding-right: 8rem;\n}\n\n.tittle{\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 2rem;\n    font-weight: 700;\n}\n\n.modal-size{\n    width: 70vw; \n    max-width: 650px;\n}\n\n.neocheck-size{\n    width: 60vw;\n}\n\n\n\n@media screen and (min-width: 2560px){\n    .content-size{\n        max-height: auto ;\n    }\n}\n\n\n@media screen and (min-width: 1920px) and (max-width: 2559px){\n    .modal-size{\n        width: 70vw; \n        max-width: 650px;\n    }\n    \n    .neocheck-size{\n        width: 70vw;\n    }\n    \n    .content-size{\n        max-height: 90vh;\n    }\n}\n\n@media screen and (min-width: 1366px) and (max-width: 1919px){\n    .modal-size{\n        width: 70vw; \n        max-width: 650px;\n    }\n    \n    .neocheck-size{\n        width: 95vw;\n    }\n    \n    .content-size{\n        max-height: 90vh;\n    }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1365px){\n    .content-size{\n        max-height: 90vh;\n    }\n}\n\n@media screen and (max-width: 480px){\n    .neocheck-size{\n        width: 85vw;\n    }\n    .modal-size{\n        width: 85vw; \n      }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
